export default {
  session (state) {
    return state.session
  },
  downloadLink_copy (state) {
    return state.downloadLink_copy
  },
  downloadLink_qrcode (state) {
    return state.downloadLink_qrcode
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Common/getters.js